import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/useDependencyData.ts";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.some.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useStoreMap } from 'effector-react';
import { sortDependencyWithModelsBySourceClassifiers } from "../../helpers";
import { isTreeBimNode } from "./types";
export function useDependencyData(_ref) {
  var dependenciesWithModels$ = _ref.dependenciesWithModels$,
      currentEntity = _ref.currentEntity,
      reference = _ref.reference,
      node = _ref.node;
  return useStoreMap({
    store: dependenciesWithModels$,
    keys: [node],
    fn: function fn(dependenciesWithModels, _ref2) {
      var _bimLeafNode;

      var _ref3 = _slicedToArray(_ref2, 1),
          node = _ref3[0];

      if (!node || !reference) {
        return null;
      }

      var sortedDependenciesWithModels = sortDependencyWithModelsBySourceClassifiers(currentEntity, dependenciesWithModels);

      if (!sortedDependenciesWithModels) {
        return null;
      }

      var sourceClsData = sortedDependenciesWithModels.find(function (_ref4) {
        var _reference$source;

        var classifier = _ref4.classifier;
        return classifier.id === ((_reference$source = reference.source) === null || _reference$source === void 0 ? void 0 : _reference$source.sourceClassifierId);
      });

      if (!sourceClsData) {
        return null;
      }

      var displayNumber = "".concat(sortedDependenciesWithModels.indexOf(sourceClsData) + 1);
      var name = sourceClsData.classifier.name;

      if (sourceClsData.classifier.type === 'UserClassifier' && !reference.element.source) {
        var element = reference.element;
        var modelDisplayNumber = sourceClsData.models.findIndex(function (_ref5) {
          var id = _ref5.id,
              version = _ref5.version;
          return element.type === 'BimModelNode' ? id === element.id && version === element.version : id === element.modelId && version === element.modelVersion;
        }) + 1;
        return {
          displayNumber: "".concat(displayNumber, ".").concat(modelDisplayNumber),
          name: name,
          source: {
            id: sourceClsData.classifier.id,
            version: sourceClsData.classifier.version
          }
        };
      }

      var bimLeafNode = isTreeBimNode(node) && (node.type === 'BimElementNode' || !node.total) ? node : null;

      if (node.type === 'DynamicReferenceNode' && node.element.type === 'BimElementNode') {
        bimLeafNode = node.element;
      }

      if ((sourceClsData.classifier.type === 'AssemblyClassifier' || sourceClsData.classifier.type === 'UserClassifier') && (_bimLeafNode = bimLeafNode) !== null && _bimLeafNode !== void 0 && _bimLeafNode.source) {
        var _bimLeafNode2 = bimLeafNode,
            source = _bimLeafNode2.source;

        var _modelDisplayNumber = sourceClsData.models.findIndex(function (_ref6) {
          var id = _ref6.id,
              version = _ref6.version;
          return source === null || source === void 0 ? void 0 : source.some(function (_ref7) {
            var modelId = _ref7.modelId,
                modelVersion = _ref7.modelVersion;
            return modelId === id && modelVersion === version;
          });
        }) + 1;

        return {
          displayNumber: _modelDisplayNumber > 0 ? "".concat(displayNumber, ".").concat(_modelDisplayNumber, " ") : "".concat(displayNumber),
          name: name,
          source: {
            id: sourceClsData.classifier.id,
            version: sourceClsData.classifier.version
          }
        };
      }

      return {
        displayNumber: displayNumber,
        name: name,
        source: {
          id: sourceClsData.classifier.id,
          version: sourceClsData.classifier.version
        }
      };
    }
  });
}